import React from 'react';
import { Icon, notification } from 'tea-component';
import './index.scss';
/**
 * 下载通知类型
 */
export type TDownloadTipType = 'loading' | 'success' | 'error';

/**
 * 通知显示时长常量
 */
const NOTIFICATION_DURATION = {
  /** 加载中：不自动关闭 */
  LOADING: 0,
  /** 成功/失败：1000 后自动关闭 */
  DEFAULT: 1000,
} as const;

/**
 * 下载提示工具函数
 * 用于显示下载过程中的状态提示（加载中、成功、失败）
 * 
 * @param type - 通知类型：'loading' | 'success' | 'error'
 * @param title - 通知内容
 * @param duration - 可选，显示时长（毫秒），默认 200ms
 * @returns notification 实例，可用于手动销毁
 * 
 * @example
 * ```tsx
 * const notification = downDataTip('loading', '下载中...');
 * // 200ms 后自动关闭
 * ```
 */
export const downDataTip = (
  type: TDownloadTipType,
  title: React.ReactNode,
  duration?: number,
) => {
  const displayDuration = duration ?? NOTIFICATION_DURATION.DEFAULT;
  const className = `downDataBox downData${type} dba-down-data-tip dba-down-data-tip--${type}`;
  // 错误类型使用 error 通知
  if (type === 'error') {
    return notification.error({
      className,
      description: title,
      duration: displayDuration,
    });
  }

  // loading 类型显示加载图标
  const loadingIcon = (
    <>
      {type === 'loading' && (
        <Icon size="l" type="loading" className="loading-icon" />
      )}
      {title}
    </>
  );

  // success 和 loading 类型使用 success 通知（样式相同）
  return notification.success({
    className,
    description: loadingIcon,
    duration: type === 'loading' ? NOTIFICATION_DURATION.LOADING : displayDuration,
  });
};
